import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var TextItem = function TextItem(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_jsx(UIText2, {
    display: "inline",
    children: value
  });
};